import { render, staticRenderFns } from "./ViewTelaTutorial.vue?vue&type=template&id=54671ffb&scoped=true"
import script from "./ViewTelaTutorial.vue?vue&type=script&lang=js"
export * from "./ViewTelaTutorial.vue?vue&type=script&lang=js"
import style0 from "./ViewTelaTutorial.vue?vue&type=style&index=0&id=54671ffb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54671ffb",
  null
  
)

export default component.exports